export default __webpack_public_path__ + "static/media/913.f2bf17eb.jpg";